<template>
  <v-container class="minHeight"
               v-if="loaded">
    <v-card v-if="!hasRows"
            class="py-4">
      <advice color="primary">
        <p v-html="$t('profile.creditcardsList.noCards')"></p>
      </advice>
    </v-card>

    <v-card v-else>

      <v-layout row
                class="pb-4">
        <v-flex xs12>
          <v-data-table :headers="headers"
                        :items="cards"
                        hide-actions
                        expand
                        item-key="code">
            <template slot="items"
                      slot-scope="props">
              <td class="text-xs-left">{{ props.item.alias }}</td>
              <td class="text-xs-right">{{ props.item.expired | formatDatePark }}</td>
              <td class="justify-center layout px-0">
                <v-btn icon
                       class="error"
                       color="error"
                       outline
                       @click="showCreditCardDeleteDialog(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <delete-credit-card :card="selectedCard"
                    v-if="isShowingCreditCardDeleteDialog"
                    @on-success="getuserCards"
                    @on-close="closeCreditCardDeleteDialog"></delete-credit-card>

  </v-container>
</template>

<script>
import Advice from '@/components/commons/Advice';
import creditCardService from '@/services/creditCardService';
import manageErrorService from '@/services/manageErrorService';
import DeleteCreditCard from '@/components/private/user/DeleteCreditCard';
export default {
  name: 'CreditCardsList',
  components: {
    [Advice.name]: Advice,
    [DeleteCreditCard.name]: DeleteCreditCard
  },
  computed: {

    headers() {
      return [
          {
            i18nText: 'global.creditCard.card',
            text: this.$i18n.t('global.creditCard.card'),
            align: 'left',
            value: 'code'
          },
          {
            i18nText: 'globa.creditCard.expires',
            text: this.$i18n.t('global.creditCard.expires'),
            align: 'right',
            value: ''
          },
          {
            i18nText: '',
            text: '',
            align: 'right',
            value: ''
          }
        ];
    }
  },
  data() {
    return {
      loaded: false,
      hasRows: false,
      isShowingCreditCardDeleteDialog: false,
      selectedCard: {},
      cards: []
    };
  },
  mounted() {},
  created() {
    this.getuserCards();
  },
  destroyed() {},
  methods: {
    async getuserCards() {
      let params = {};
      let results = await creditCardService.list(params);

      if (results.error) {
        manageErrorService.handle(results.data);
        return;
      }

      this.cards = results.data;

      if (this.cards.length === 0) {
        this.hasRows = false;
      } else {
        this.hasRows = true;
      }
      this.loaded = true;
    },
    showCreditCardDeleteDialog(item) {
      this.isShowingCreditCardDeleteDialog = true;
      this.selectedCard = item;
    },
    closeCreditCardDeleteDialog() {
      this.isShowingCreditCardDeleteDialog = false;
      this.selectedCard = {};
    }
  }
};
</script>
